import React from 'react';
import { shape, arrayOf } from 'prop-types';
import { connect } from 'react-redux';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import Notification, { NotificationShape } from './notification';
import { addNotification } from './actions';

export const TRANSITION_DURATION = 200;

export const animationTimeout = {
  enter: TRANSITION_DURATION,
  exit: TRANSITION_DURATION,
};

const Notifications = ({ notifications }) => (
  <TransitionGroup className="mdc-notifications">
    {notifications.map(
      notification => (
        <CSSTransition
          key={notification.key || notification.datetime}
          classNames="notification"
          timeout={animationTimeout}
        >
          <Notification notification={notification} />
        </CSSTransition>
      ),
    )}
  </TransitionGroup>
);

Notifications.propTypes = {
  notifications: arrayOf(shape(NotificationShape)).isRequired,
};

export default connect(
  ({ notifications }) => ({
    notifications,
  }),
  dispatch => ({
    notificationAdd: notification => dispatch(addNotification(notification)),
  }),
)(Notifications);
